export default __webpack_public_path__ + "static/media/Video-Icon.0d9cc088.svg";